import React, { useEffect, useCallback, useState, useRef, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";

import useForm18nValidation from "../../../utils/use-form-i18n-validation";

import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import CardWeather, { WeatherInfoTemplate, ForecastItemTemplate, weatherThemeSettings } from "./CardWeather";

import FormControl from "@mui/material/FormControl";
import { Autocomplete } from "@react-google-maps/api";

import { useForm, FormContainer, TextFieldElement, SelectElement, CheckboxElement, FormProvider } from 'react-hook-form-mui';
import { addWidget } from "../../../redux/actions/Content";
import { InputLabel, MenuItem, Select } from "@mui/material";
import toast from "react-hot-toast";

export default function DialogBoxWeather({ isOpen, onClose, isIcon, onAddWidget, startupData }) {

  const { t } = useTranslation();

  const locationInputRef = useRef();
  const placeObjectRef = useRef(null);

  
  const { user } = useSelector((state) => state.User);
  const { currentFolder } = useSelector((state) => state.FileFolder);

  const [weather, setWeather] = useState({
    name: '',
    scale: '',
    language: '',
    location: {
      formattedAddress: null,
    },
    fontSize: '',
    theme: '',
    place: '',
  })

  useEffect(() => {
    setWeather({
      name: startupData ? startupData.name : '',
      scale: startupData ? startupData.widget.weather.scale : 'F',
      language: startupData ? startupData.widget.weather.language : 'en',
      location: {
        formattedAddress: startupData ? startupData.widget.weather.location.formattedAddress : null,
      },
      fontSize: startupData ? startupData.widget.weather.fontSize : 'L',
      theme: startupData ? startupData.widget.weather.theme : '#90EE90',
      place: startupData ? startupData.widget.weather.location.formattedAddress : '',
    })
  }, [])

  const weatherScaleOptions = useMemo(() => ([
    { id: "F", label: t("views.dialogBoxWeather.fahrenheit") },
    { id: "C", label: t("views.dialogBoxWeather.celsius") }
  ]), [t]);

  const weatherLanguageOptions = useMemo(() => ([
    { id: "en", label: t("views.dialogBoxWeather.language.en") },
    { id: "es", label: t("views.dialogBoxWeather.language.es") },
    { id: "de", label: t("views.dialogBoxWeather.language.de") },
    { id: "pl", label: t("views.dialogBoxWeather.language.pl") }
  ]), [t]);

  const weatherFontSizeOptions = useMemo(() => ([
    { id: "S", label: t("views.dialogBoxWeather.sizeS") },
    { id: "L", label: t("views.dialogBoxWeather.sizeL") },
    { id: "XL", label: t("views.dialogBoxWeather.sizeXL") },
    { id: "XXL", label: t("views.dialogBoxWeather.sizeXXL") }
  ]), [t]);

  const weatherThemeOptions = useMemo(() => ([
    { id: "#90EE90", label: t("views.dialogBoxWeather.black") },
    { id: "#808080", label: t("views.dialogBoxWeather.yellow") }
  ]), [t]);

  const handleLocationChange = () => {
    const placeObject = locationInputRef.current.getPlace();

    placeObjectRef.current = placeObject;

    const lat = placeObject.geometry.location.lat();
    const lng = placeObject.geometry.location.lng();
    const formattedAddress = placeObject.formatted_address;

    setWeather({...weather, place: formattedAddress, location: {lat: lat, lng: lng, formattedAddress: formattedAddress}})
  }

  console.log(startupData)

  const resetForm = () => {
    setWeather({
      name: startupData ? startupData.name : '',
      scale: startupData ? startupData.widget.weather.scale : 'F',
      language: startupData ? startupData.widget.weather.language : 'en',
      location: {
        formattedAddress: startupData ? startupData.widget.weather.location.formattedAddress : null,
        lat: startupData ? startupData.widget.weather.location.lat : null,
        lng: startupData ? startupData.widget.weather.location.lng : null,
      },
      fontSize: startupData ? startupData.widget.weather.fontSize : 'L',
      theme: startupData ? startupData.widget.weather.theme : '#90EE90',
      place: startupData ? startupData.widget.weather.location.formattedAddress : '',
    })
  }

  const handleClose = () => {
    onClose?.(false);
    resetForm()
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if(weather.location.formattedAddress && weather.location.lat && weather.location.lng){
      onAddWidget({
        name: weather.name,
        type: "widget",
        widgetCat: "weather",
        widgetIcon: isIcon,
        url: "",
        html: "",
        weather: {
          scale: weather.scale,
          language: weather.language,
          location: weather.location,
          fontSize: weather.fontSize,
          theme: weather.theme,
          template: WeatherInfoTemplate,
          forecastItemTemplate: ForecastItemTemplate,
          themeSettings: weatherThemeSettings(weather.theme)
        },
        folderId: currentFolder,
        user: user._id,
      });
      handleClose()
    }else{
      toast.error("Enter location")
    }
  }

  useEffect(() => {
    placeObjectRef.current = null;
    resetForm();
  }, [isOpen])

  return (
    <div>
      <Dialog open={isOpen} onClose={handleClose} maxWidth="lg" fullWidth>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingTop: "20px",
          }}>
          <img src="/images/weather-widget.png" style={{width: "70%", maxWidth: "200px"}} />
        </div>
        <DialogTitle sx={{ textAlign: "center" }}>{t("views.dialogBoxWeather.weather")}</DialogTitle>
          <form onSubmit={handleSubmit}>
            <DialogContent>
              <TextField
                autoFocus
                margin="dense"
                label={t("views.dialogBoxWeather.name")}
                type="text"
                fullWidth
                variant={"outlined"}
                name="name"
                value={weather.name}
                onInput={(e) => setWeather({...weather, name: e.target.value})}
                required
                disabled={startupData ? true : false}
              />
              <br/>
              <br/>
              <FormControl fullWidth>
                <Autocomplete onLoad={(autocomplete) => (locationInputRef.current = autocomplete)} onPlaceChanged={handleLocationChange}>
                  <TextField
                    fullWidth
                    label={t("views.dialogBoxWeather.location")}
                    required
                    value={weather.place}
                    onInput={(e) => setWeather({...weather, place: e.target.value})}
                  />
                </Autocomplete>
              </FormControl>
              <br />
              <br />
              <FormControl fullWidth>
                <InputLabel id="scale-select-label">{t("views.dialogBoxWeather.scale")}</InputLabel>
                <Select
                  labelId="scale-select-label"
                  id="scale-select"
                  label={t("views.dialogBoxWeather.scale")}
                  value={weather.scale}
                  onChange={(e) => setWeather({...weather, scale: e.target.value})}
                  required
                >
                  {weatherScaleOptions.map(option => {
                    return (
                      <MenuItem value={option.id} key={option.id}>{option.label}</MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
              <br />
              {/* <CheckboxElement name="useDeviceLocation" size="small" label={t("views.dialogBoxWeather.useDeviceLocation")} /> */}
              {/* <br /> */}
              <br />
              <FormControl fullWidth>
                <InputLabel id="lang-select-label">{t("views.dialogBoxWeather.selectLanguage")}</InputLabel>
                <Select
                  labelId="lang-select-label"
                  id="lang-select"
                  label={t("views.dialogBoxWeather.selectLanguage")}
                  required
                  value={weather.language}
                  onChange={(e) => setWeather({...weather, language: e.target.value})}
                >
                  {weatherLanguageOptions.map(option => {
                    return (
                      <MenuItem value={option.id} key={option.id}>{option.label}</MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
              <br />
              <br />
              <FormControl fullWidth>
                <InputLabel id="fontsize-select-label">{t("views.dialogBoxWeather.selectFontSize")}</InputLabel>
                <Select
                  labelId="fontsize-select-label"
                  id="fontsize-select"
                  label={t("views.dialogBoxWeather.selectFontSize")}
                  value={weather.fontSize}
                  onChange={(e) => setWeather({...weather, fontSize: e.target.value})}
                  required
                >
                  {weatherFontSizeOptions.map(option => {
                    return (
                      <MenuItem value={option.id} key={option.id}>{option.label}</MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
              <br />
              <br />
              <FormControl fullWidth>
                <InputLabel id="theme-select-label">{t("views.dialogBoxWeather.selectTheme")}</InputLabel>
                <Select
                  labelId="theme-select-label"
                  id="theme-select"
                  label={t("views.dialogBoxWeather.selectTheme")}
                  required
                  value={weather.theme}
                  onChange={(e) => setWeather({...weather, theme: e.target.value})}
                >
                  {weatherThemeOptions.map(option => {
                    return (
                      <MenuItem value={option.id} key={option.id}>{option.label}</MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
              <h5>{t("views.dialogBoxWeather.preview")}</h5>
              <CardWeather item={{
                weather: weather
              }} />
              <br />
            </DialogContent>
            <DialogActions
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 2,
                marginTop: 1,
              }}>
              <Button variant="outline" color="primary" type="button" onClick={handleClose}>
                {t("views.dialogBoxWeather.cancel")}
              </Button>

              <Button variant="contained" color="primary" type="submit">
                {t("views.dialogBoxWeather.save")}
              </Button>
            </DialogActions>
          </form>
      </Dialog>
    </div>
  );
}
